var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.left",modifiers:{"hover":true,"left":true}}],staticClass:"btn-primary btn clickable help-btn",attrs:{"title":_vm.$t('shared.chat.help')},on:{"click":_vm.helpClick}},[_c('BaseIcon',{staticClass:"icon",attrs:{"name":"question"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }